import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./LiveTrack.scss";
import LiveTracking from "../../components/LiveTracking/LiveTracking";
import JobService from "../../services/JobService";
import { JobOrder } from "../../interfaces/job.interface";
import { useLoader } from "../../contexts/LoaderContext";
import Loader from "../../components/Loader/Loader";

function LiveTrack() {
  const { jobId, tripId } = useParams();
  const [job, setJob] = useState<JobOrder | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchJob = async () => {
      try {
        showLoader();
        setLoading(true);
        const response = await JobService.getJobDetails(parseInt(jobId || "0"));
        if (response.data && !response.data.error) {
          setJob(response.data.data);
        } else {
          setError("Failed to fetch job details");
        }
      } catch (error) {
        console.error("Error fetching job:", error);
        setError("An error occurred while fetching job details");
      } finally {
        setLoading(false);
        setTimeout(() => {
          hideLoader();
        }, 1000);
      }
    };

    if (jobId) {
      fetchJob();
    }
  }, [jobId, showLoader, hideLoader]);

  if (!loading && error) {
    return (
      <div className="live-track-page">
        <div className="error-container">
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  if (!loading && !job) {
    return (
      <div className="live-track-page">
        <div className="error-container">
          <p className="error-message">No job details found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex live-track-page">
      {!loading && job && (
        <LiveTracking job={job} jobBreakupDetailId={parseInt(tripId || "0")} />
      )}
    </div>
  );
}

export default LiveTrack;
